import React from 'react';
import PropTypes from 'prop-types';

class GuestUploadsRow extends React.Component {
  state = {
    deleteMode: false
  }

  toggleDeleteMode = () => {
    this.setState((prevState) => ({
      deleteMode: !prevState.deleteMode,
      editMode: !prevState.deleteMode ? false : prevState.editMode
    }));
  }

  deleteLink = () => {
    const { link, deleteGuestUploadLink } = this.props;
    deleteGuestUploadLink(link.key);
  }

  renderLink() {
    const { key, created_at, description, named_section, created_by } = this.props.link;
    return (
      <React.Fragment>
        <span className="ten">
          <a
            href={`/guest_upload/${key}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit link
          </a>
        </span>
        <span className="forty">
          {((description && description.length > 60) ? `${description.substring(0, 60)}...` : description) || '-'}
        </span>
        <span className="fifteen">
          {(created_by && created_by.length > 20) ? `${created_by.substring(0, 20)}...` : created_by}
        </span>
        <span className="ten">
          <a
            href={`/${BF.fx.brandfolder().slug}?q=section.strict:"${named_section}"`}
            target="_blank"
            rel="noopener noreferrer"
          >
            {(named_section && named_section.length > 20) ? `${named_section.substring(0, 20)}...` : named_section}
          </a>
        </span>
        <span className="ten center">
          { this.props.formatDate(created_at) }
        </span>
        <button
          className="delete-upload-button five center"
          onClick={this.toggleDeleteMode}
          type="button"
        >
          <span className="bff-trash" />
        </button>
      </React.Fragment>
    );
  }

  renderDelete() {
    const { key } = this.props.link;
    return (
      <span className="delete-upload-mode">
        <div className="upload-link-info">
          <span className="ten">
            <a
              href={`/guest_upload/${key}`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Visit link
            </a>
          </span>
        </div>
        <div className="delete-buttons">
          <button
            className="button tertiary cancel"
            type="button"
            onClick={this.toggleDeleteMode}
          >
            {t("Cancel")}
          </button>
          <button
            className="button warning"
            type="button"
            onClick={this.deleteLink}
          >
            {t("Delete Link")}
          </button>
        </div>
      </span>
    );
  }

  render() {
    if (this.state.deleteMode) { return this.renderDelete(); }
    return this.renderLink();
  }
}

GuestUploadsRow.propTypes = {
  link: PropTypes.shape({
    key: PropTypes.string,
    created_at: PropTypes.string,
    description: PropTypes.string,
    enabled: PropTypes.bool,
    created_by: PropTypes.string,
    named_section: PropTypes.string
  }).isRequired,
  deleteGuestUploadLink: PropTypes.func.isRequired,
  formatDate: PropTypes.func.isRequired
};

export default GuestUploadsRow;
